import React, { Component } from 'react'

import { loginModel } from 'pluton-core/lib/models/auth/login.model';
import { settingsModel } from 'pluton-core/lib/models/service/settings.model';
import { errorModel } from 'pluton-core/lib/models/service/error.model';
import { alertModel } from 'pluton-core/lib/models/core/alert.model';
import { init as storageInit } from 'pluton-core/lib/device/storage';

import configureStore from '../store';
import Routes from './Routes.jsx';
import { initHistory, history } from '../history';

const store = configureStore();
initHistory(store);

storageInit();

store.dispatch(alertModel.actionStorageInit(alertModel));
store.dispatch(errorModel.actionStorageInit(errorModel));
store.dispatch(settingsModel.actionStorageInit(settingsModel));
store.dispatch(loginModel.actionStorageInit(loginModel));


class Root extends Component {
    render() {
        return (
            <Routes store={store} history={history}/>
        );
    }
}

export default Root;



// WEBPACK FOOTER //
// ./app/entry/components/Root.jsx